import MfeProvider from './mfe-provider.component'

export default MfeProvider
